import { Unites } from '../referentials-units/unites.model';

export class TypePrestation {
  codeHecate: number;
  designation: string;
  transport: boolean;
  suffisantPourDemande: boolean;
  afficherSurLaConfirmation: boolean;
  id: number;
  envoiTennaxia: boolean;
  unite: Unites | null;
  constructor(afficherSurLaConfirmation: boolean, codeHecate: number, designation: string, envoiTennaxia: boolean, id: number, suffisantPourDemande: boolean, transport: boolean, unite: Unites | null = null) {
    this.codeHecate = codeHecate;
    this.designation = designation;
    this.transport = transport;
    this.suffisantPourDemande = suffisantPourDemande;
    this.afficherSurLaConfirmation = afficherSurLaConfirmation;
    this.id = id;
    this.envoiTennaxia = envoiTennaxia;
    this.unite = unite;
  }
}
